module.exports = __webpack_public_path__ + "assets/img/shortsPlatform-broker-list.c0bead64.png";